module.exports = __webpack_public_path__ + "img/Meow Pop Blast.06a163d0.png";